import React from "react";
import cn from "classnames";
import { Button, WidthContainer, TransparentVideo } from "~components";
import { useBreakpoints } from "~hooks";
import { GatsbyImage } from "gatsby-plugin-image";
import * as styles from "./styles.module.scss";

const ProductFeatureBanner = ({
  featuredProduct,
  imageOrVideo,
  backgroundImage,
  backgroundVideo,
  backgroundColor,
  textColor
}) => {
  const { shortDescription, shopifyData } = featuredProduct;
  const { handle: slug, title, variants } = shopifyData[0];
  const { price } = variants[0].presentmentPrices[0];

  const breakpoints = useBreakpoints();

  const buttonText = `View product`;

  return (
    <div
      className={styles.container}
      style={{ backgroundColor: backgroundColor?.hex, color: textColor?.hex }}
    >
      <WidthContainer>
        <div className={styles.content}>
          <div>
            <h2 className={cn(`h2`, styles.title)}>{title}</h2>
            <div className={cn(`h3`, styles.price)}>
              ${price.amount}
              {` `}
              <span className="caption">{price.currencyCode}</span>
            </div>
          </div>
          {imageOrVideo === `image` && backgroundImage && (
            <div className={styles.imageContainer}>
              <GatsbyImage
                image={backgroundImage.asset.gatsbyImageData}
                alt={backgroundImage.asset.alt || ``}
                objectFit="contain"
                className="gatsbyImage"
              />
            </div>
          )}
          {imageOrVideo === `video` && backgroundVideo && (
            <div className={styles.videoContainer}>
              <TransparentVideo
                mov={backgroundVideo?.mov}
                webM={backgroundVideo?.webM}
              />
            </div>
          )}
          <div>
            <p className={cn(`b1`, styles.description)}>{shortDescription}</p>
            <Button
              to={`/products/${slug}`}
              variant="primary"
              fluid={!breakpoints.tablet}
              className={styles.button}
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </WidthContainer>
    </div>
  );
};

export default ProductFeatureBanner;
